// VerifyRecoveryEmail — public page reached via the user verification link.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';
import { ShieldCheck, AlertCircle, Loader2, CheckCircle2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const VerifyRecoveryEmail = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState({ loading: true, ok: false, msg: '', masked: '' });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, msg: 'Link inválido. Solicite uma nova confirmação.', masked: '' });
      return;
    }
    (async () => {
      try {
        const r = await axios.post(`${API}/api/auth/recovery-email/verify`, { token });
        setState({
          loading: false,
          ok: true,
          msg: r.data?.message || 'E-mail confirmado.',
          masked: r.data?.email_recuperacao_mascarado || '',
        });
      } catch (err) {
        setState({
          loading: false,
          ok: false,
          msg: err?.response?.data?.detail || 'Não foi possível confirmar o e-mail.',
          masked: '',
        });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white rounded-lg shadow-md border border-[#E2E8F0] p-6 text-center"
           data-testid="verify-recovery-page">
        <div className="w-12 h-12 mx-auto bg-[#006030] rounded-md flex items-center justify-center mb-3">
          <ShieldCheck className="w-5 h-5 text-white" />
        </div>
        <h1 className="text-xl font-black text-[#0F1C2E]">Confirmação de e-mail</h1>
        <p className="text-xs text-[#475569] mt-1">Tô de Olho</p>

        <div className="mt-5">
          {state.loading ? (
            <div className="flex flex-col items-center gap-2 text-[#475569] text-xs">
              <Loader2 className="w-5 h-5 animate-spin" /> Confirmando...
            </div>
          ) : state.ok ? (
            <div className="flex flex-col items-center gap-2" data-testid="verify-recovery-ok">
              <CheckCircle2 className="w-8 h-8 text-[#006030]" />
              <p className="text-sm font-bold text-[#0F1C2E]">{state.msg}</p>
              {state.masked && <p className="text-xs text-[#475569]">{state.masked}</p>}
            </div>
          ) : (
            <div className="flex flex-col items-center gap-2" data-testid="verify-recovery-err">
              <AlertCircle className="w-8 h-8 text-[#DC2626]" />
              <p className="text-sm font-bold text-[#0F1C2E]">{state.msg}</p>
            </div>
          )}
        </div>

        <Link to="/" className="mt-6 inline-block text-xs font-bold text-[#006030] hover:underline">
          Ir para a página inicial
        </Link>
      </div>
    </div>
  );
};

export default VerifyRecoveryEmail;
